<template>
  <DataProvider
    :cache="true"
    :url="dataSource"
    method="GET"
    @loaded="onDataLoaded"
    @error="onDataError"
    v-slot="{ data, error, loading }">

    <div class="home">
      <div style="border-top: 1px solid transparent; margin-bottom: -1px; visibility: hidden;"></div>
      <div class="home__loading" v-show="loading">
        <SvgSymbol use="#spinner"/>
      </div>
      <ElectPresident :data="president"/>
      <ElectLegislator :data="legislator"/>
      <ElectMayor :data="mayor"/>
    </div>

  </DataProvider>
</template>

<script>
import DataProvider from '@/components/DataProvider'
import ElectPresident from '@/components/ElectPresident'
import ElectLegislator from '@/components/ElectLegislator'
import ElectMayor from '@/components/ElectMayor'

export default {
  name: 'home',
  components: {
    DataProvider,
    ElectPresident,
    ElectLegislator,
    ElectMayor
  },
  props: {
    year: { type: String, required: true }
  },
  data () {
    return {
      data: {}
    }
  },
  computed: {
    dataSource () {
      const base = this.$router.options.base
      const path = `/data/${this.year}.json`
      return (base !== '/')
        ? `${base}${path}`
        : path
    },
    president () {
      return this.data.president
    },
    legislator () {
      return this.data.legislator
    },
    mayor () {
      return this.data.mayor
    }
  },
  methods: {
    onDataLoaded (data) {
      this.data = data
    },
    onDataError (err) {
      console.warn('[DataProvider] error', err)
    }
  }
}
</script>

<style lang="scss">
.home {
  position: relative;
  min-height: 100vh;
  @include rwd($RWD_DESKTOP_WIDE) {
    padding-left: 60px;
  }

  &__loading {
    display: block;
    position: absolute;
    top: 50px;
    left: 50%;
    width: 40px;
    height: 40px;
    transform: translate(-50%, 0);
  }
}

section {
  display: block;
  position: relative;
  // min-height: 100vh;

  @include rwd($RWD_DESKTOP_WIDE) {
    display: inline-block;
    width: 50%;
    vertical-align: top;
  }

  &:nth-of-type(2n + 1) {
    @include rwd($RWD_DESKTOP_WIDE) {
      left: -60px;
    }
  }

  &:nth-of-type(1).elect-mayor {
    @include rwd($RWD_DESKTOP_WIDE) {
      left: 0;
      width: 100%;
    }
  }
}

.the-comments {
  @include rwd($RWD_DESKTOP_WIDE) {
    left: -30px;
  }
}
</style>
